//@ts-strict-ignore
import React from 'react';
import Workspace from '../../components/Workspace/Workspace';
import fieldMetaData from '../../graphql/schema/fieldMetaData';
import Formatters from '../../components/grid-addons/formatters';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import { ImportedWooCommerceOrder } from '../../graphql/entities';
import { Direction, IImportedWooCommerceOrder } from '../../graphql/schema/p4types';
import { Paths } from '../../@types/keyOfNested';

const IMPORTED_WOO_COMMERCE_FIELD_NAMES: Array<Paths<IImportedWooCommerceOrder>> = [
  'createdAt',
  'wooCommerceConfiguration.name',
  'orderReference',
  'salesOrder.orderNumber',
  'orderImportFailureReason',
  'failureDescription',
  'resolved',
];

const IMPORTED_WOO_COMMERCE_COLUMN_OVERRIDES = {
  orderImportFailureReason: {
    options: fieldMetaData.OrderImportFailureReason,
    formatter: Formatters.EnumFormatter,
  },
};

const ImportedWooCommerceOrderWorkspace = (props) => {
  const workspaceProps = useWorkspace<IImportedWooCommerceOrder>(props, ImportedWooCommerceOrder, {
    columns: IMPORTED_WOO_COMMERCE_FIELD_NAMES,
    columnOverrides: IMPORTED_WOO_COMMERCE_COLUMN_OVERRIDES,
    initialSortColumn: 'createdAt',
    initialSortDirection: Direction.Desc,
  });

  return (
    <Workspace
      entityType={ImportedWooCommerceOrder.type}
      title={ImportedWooCommerceOrder.title}
      formUrl={ImportedWooCommerceOrder.formUrl}
      defaultQuery={ImportedWooCommerceOrder.workspace}
      entity={ImportedWooCommerceOrder}
      permittedOperations={ImportedWooCommerceOrder.operations}
      {...workspaceProps}
      {...props}
    />
  );
};

export default ImportedWooCommerceOrderWorkspace;
